import React from "react";
import "./EventStyle.scss";
import { eventTextContent } from "./constant/index";
import CustomButton from "../Common_UI_Kit/CustomButton";

const EventSection = () => {
  return (
    <section className="event-section">
      <div className="event-container">
        <div className="event-wrap">
          <div className="img-box">
            <img src={eventTextContent.imageSrc} alt="Images" />
          </div>
          
          <div className="text-box">
            <h5 className="subtitle-text">{eventTextContent.subtitleText}</h5>
            <img src={eventTextContent.imageSrcSigma} alt="Images" />
          </div>

          <div className="event-text-box">
            <h1 className="date-text">{eventTextContent.dateText}</h1>
            <h2 className="month-text">{eventTextContent.monthText}</h2>
            <div className="btn-box">
              <CustomButton buttonType="secondary" label={eventTextContent.btnText} onClick={() => { window.open('https://www.gammastack.com/', '_blank') }}/>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EventSection;
